import React, { PropTypes } from 'react';

const CasoForm = ({onSubmit, onChange, caso,onChangeAnswer, onChangeQuestion,addQuestion,deleteQuestion,addAnswer,deleteAnswer,onCancel}) => (

      <div className="col s12 m12 l12 white">

      <form className="col s12" onSubmit={onSubmit}>
        <h3 className="center">Caso Clinico</h3>

        <div className="row">
          <div className="input-field col s10 offset-s1">
            <textarea onChange={onChange} className="materialize-textarea z-depth-1" name="description" id="description" value={caso.description} />
            <label>Caso clinico</label>
          </div>
        </div>
        <div className="row">
          <div className="row">
            <div className="col s8">
              <h4 className="center">Preguntas:</h4>
            </div>
            <div className="col s4">
              <a style={{marginTop:'15px'}} onClick={addQuestion} className="btn-large black">Agregar Pregunta<i className="material-icons left">add</i></a>
            </div>

          </div>
          {proccessQuestions(caso.questions,onChange,onChangeAnswer,onChangeQuestion,deleteQuestion,addAnswer,deleteAnswer)}

        </div>
        <div className="divider"></div>

        <div className="row">
          <div className="col s12">
          <div className="col s6 m6">
          <p className="left-align"><a onClick={onCancel} className="btn-large">Cancelar</a></p>
          </div>
          <div className="col s6 m6">
          <p className="right-align"><button type="submit" className="btn-large">Guardar</button></p>
          </div>
          </div>

        </div>
      </form>
    </div>

  )
//TODO Refactor.. v2
let proccessQuestions = (questions, onChange, onChangeAnswer, onChangeQuestion,deleteQuestion,addAnswer,deleteAnswer) => {
    let theQuestions = questions.map((question,index) => {
        const last = question.answers.length;
        let answers = question.answers.map((answer,index2) => {
        let keyName = "questions["+index+"][answers]["+index2+"]";

          let keyId = index+'-'+index2;


          return(
          <div className="row" key={keyId}>
            <div className="col s10 offset-s1">
              <div className="col s8 input-field">
                <input type="text" id={'answer-'+keyId}  name="text" value={answer.text}  onChange={(event) => onChangeAnswer(index,index2,event)} />
              </div>
              <div className="col s2" >
                <input name="is_correct" id={keyName+"[is_correct]"} type="checkbox" checked={answer.is_correct}  onChange={(event) => { onChangeAnswer(index,index2,event) }} />
                <label htmlFor={keyName+"[is_correct]"}>¿correcta?</label>
              </div>
              <div className="col s1 offset-s1 input-field" >
                <a className="btn-floating red" onClick={(event) => deleteAnswer(index,index2,event)}><i className="material-icons">delete</i></a>
              </div>
            </div>
              <div className={"input-field col s8 offset-s1 "+(answer.is_correct ? 'show' : 'hide')}>
                <textarea onChange={(event) => onChangeAnswer(index,index2,event)} className="materialize-textarea z-depth-1" name="description" id={'answer-description'+keyId} value={answer.description} />
                <label>¿Por que es correcta?</label>
              </div>

          </div>
          )
        });
        return(
          <div className="row" key={index}>
          <div className="input-field col s8 offset-s1" >
            <textarea className="materialize-textarea"  id={"question-"+index} name={"questions["+index+"][text]"}  value={question.text} onChange={(event) => onChangeQuestion(index,event)}></textarea>
            <label>Pregunta {index+1}</label>
          </div>
          <div className="input-field col offset-s1 s1">
              <a onClick={(event)=> addAnswer(index,event) } className="btn-flat"><i className="material-icons">playlist_add </i></a>
          </div>
          <div className="input-field col s1">
              <a onClick={(event)=> deleteQuestion(index,event) } className="btn-flat"><i className="material-icons">delete</i></a>
          </div>
          {answers}
          </div>
        )
    });

    return theQuestions;

}



CasoForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeAnswer: PropTypes.func.isRequired,
    onChangeQuestion: PropTypes.func.isRequired,
    deleteQuestion: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    caso: PropTypes.object.isRequired,
    addQuestion: PropTypes.func,
    addAnswer: PropTypes.func,
    deleteAnswer: PropTypes.func,
    onCancel: PropTypes.func
};

export default CasoForm;



// WEBPACK FOOTER //
// ./src/components/CasoForm.js